import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";
import { Artboard } from "./screens/Artboard/Artboard";
import { HeadJudgeDashboard } from "./components/HeadJudgeDashboard";
import { RoleBasedDashboard } from "./components/RoleBasedDashboard";
import { Login } from "./screens/Login";
import SignUp from "./screens/SignUp";
import { ForgotPassword } from "./screens/ForgotPassword";
import { ResetPassword } from "./screens/ResetPassword";
import { ChangePassword } from "./screens/ChangePassword";
import VerifyOtp from "./screens/VerifyOtp";
import { Dnf } from "./screens/Dnf";
import { Holdtime } from "./screens/Holdtime";
import { Violations } from "./screens/Violations";
import { ReviewPenalty } from "./screens/ReviewPenalty";
import { SetStation } from "./screens/SetStation";

createRoot(document.getElementById("app") as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/change-password"
            element={<ChangePassword />}
          />
          <Route
            path="/"
            element={<Login />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <RoleBasedDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/penalty-logging"
            element={
              <ProtectedRoute>
                <Artboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mark-dnf"
            element={
              <ProtectedRoute>
                <Dnf />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hold-time"
            element={
              <ProtectedRoute>
                <Holdtime />
              </ProtectedRoute>
            }
          />
          <Route
            path="/violations"
            element={
              <ProtectedRoute>
                <Violations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/set-station"
            element={<SetStation />}
          />
          <Route
            path="/review-penalty"
            element={
              <ProtectedRoute>
                <ReviewPenalty />
              </ProtectedRoute>
            }
          />
          <Route
            path="/head-judge-dashboard"
            element={
              <ProtectedRoute>
                <HeadJudgeDashboard />
              </ProtectedRoute>
            }
          />
          {/* Catch all route for 404s */}
          <Route path="*" element={<Login />} />
        </Routes>
        <PWAInstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
